import axios from 'axios';
import {setStore} from 'trim-redux';
//const kipa = 'https://api.ipg.kipaa.ir/customer';
const kipa = 'https://userapi.kipaa.ir/v1/customer';
const kipaSupp = 'https://userapi.kipaa.ir/v1/supplier';
//let paymentToken = getStore('paymentToken');

export function verifyToken(paymenttoken ){
  //  localStorage.clear();
    const headers = {
        'Accept': '*/*',
    };
    const param = {
        payment_token: paymenttoken
    };
    axios.post(`${kipa}/verify_Token` ,param, {
        headers: headers
    }).then(res => {
        if(res.data.Status === 200){
            //callBack(res.data.Content.supplier_profile.terminal_id);
            localStorage.setItem('callBackUrl' ,res.data.Content.callback_url );
            localStorage.setItem('amount' , res.data.Content.amount);
            setStore({
                loading: false,
                step: 1
            })
        }
        else{
            setStore({
               // failed: true,
                loading: false,
                errMesasage: res.data.Message,
            });
        }
    }).catch(err => {
        setStore({
            loading: false,
          //  failed: true
        })
    })
}
export function RequestToken(amount,detail,token) {
    const headers = {
        'Content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': `brear ${token}`
    };
    //const pathname = window.location.pathname.split('/')[1];
    const params = {
        amount: amount,
        currency: 'IRR',
        callBack_url: `${window.location.href}`,
        debt: null,
        min_credit: null,
        max_credit: null,
        details: detail
    };
    axios.post(`${kipaSupp}/request_payment_token` , params , {
        headers: headers
    }).then(res => {
        if(res.data.Status === 200) {
            setStore({
                paymentToken: res.data.Content.payment_token,
                paymentUrl: res.data.Content.payment_url,
            });
            verifyToken(res.data.Content.payment_token)
        }else{
            alert('خطایی در هنگام بارگزاری اطلاعات رخ داد')
        }
    }).catch(() => {
        alert('خطا در برقراری ارتباط با سرور')
    })
}
export function suppInfo(id) {
    setStore({
        loading: true
    });
    axios.post(`${kipaSupp}/supplier_info?id=${id}`)
        .then(res => {
                let obj = {};
               res.data.Sponsors.forEach(function(v){
                    obj[v.ID] = v;
                });
               let arr = [];
               let options = [];
                for(let i=0; i < Object.keys(obj).length; i++){
                   arr.push(obj[Object.keys(obj)[i]])
                }
            localStorage.setItem("supplierName" , res.data.Details.SupplierName);
            localStorage.setItem("website" , res.data.Details.WebSite) ;
            localStorage.setItem("terminalNum" , res.data.Details.TerminalNumber)
                localStorage.setItem('allSponsors' ,JSON.stringify(arr));
                localStorage.setItem('address' , res.data.Details.Address);
               
            let myArray = JSON.parse(localStorage.allSponsors);
                if(JSON.parse(localStorage.allSponsors).length !== 1){
                myArray =  JSON.parse(localStorage.allSponsors).filter(function(test) {
                  return (
                      test["Name"]!== "تست" && test["Name"] !== "تست کيپا"
                  );
                });
                }
               myArray.forEach((s) =>
                options.push({
                    value: s.ID,
                    label: s.Name
                })
            );
                setStore({
                    sponsorsOptions: options,
                    branchName: res.data.Details.BranchName,
                    branchCode: res.data.Details.BranchCode,
                });
                RequestToken("1000000000" , "", res.data.AccessToken);
        }).catch(err => {
        setStore({
            isFailed: true,
            loading: false,
        });
    })
}
export function auth(input , paymenttoken  ,isresend) {
    setStore({
        buttonLoading: true,
        buttonDisabled: true
    });
    const headers = {
        'Accept': '*/*',
    };
    const params = {
        input: input,
        payment_token: paymenttoken,
        isresend: isresend,
    };
    axios.post(`${kipa}/authentication` , params , {
        headers: headers
    }).then(res => {
        if(res.data.Status && res.data.Status === 200){
           setStore({otpExpire: res.data.Content.otp_expiration});
           setStore({
               step: 2,
               buttonLoading: false,
               buttonDisabled: false
            })
        }
        else if(res.data.Status && res.data.Status === 604){
            setStore({
                userNotFound: true,
                noContract: false,
                smsFailed: false,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
        else if(res.data.Status && res.data.Status === 418){
            setStore({
                noContract: true,
                userNotFound: false,
                smsFailed: false,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
        else if(res.data.Status && res.data.Status === 610){
            setStore({
                showModalErr: true,
                smsFailed: false,
                userNotFound: false,
                noContract: false,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
        else if(res.data.Status && res.data.Status === 9){
            setStore({
                smsFailed: true,
                userNotFound: false,
                noContract: false,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
        else{
            setStore({
                serverErr: true,
                showModalErr: true,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
    }).catch(err => {
        if(err.response.status === 418){
            setStore({
                noContract: true,
                smsFailed: false,
                userNotFound: false,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
        else if(err.response.status === 604){
            setStore({
                userNotFound: true,
                noContract: false,
                smsFailed: false,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
       else if(err.response.status === 9){
            setStore({
                smsFailed: true,
                userNotFound: false,
                noContract: false,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
        else if(err.response.status === 610){
          setStore({
              showModalErr: true,
              buttonLoading: false,
              buttonDisabled: false
          })
          
        }
        else {
            setStore({
                serverErr: true,
                showModalErr: true,
                buttonLoading: false,
                buttonDisabled: false
            })
        }
    })
}
export function getCredit(paymenttoken,accessToken) {
    const headers = {
        'content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': `brear ${accessToken}`
    };
    const params = {
        payment_token: paymenttoken,
    };
    axios.post(`${kipa}/Get_Credit`,params,{
        headers: headers
    }).then(res => {
      //  localStorage.setItem('minCredit' , res.data.Content.credit.MinCreditAmount);
       if(res.data.Status === 200) {
           localStorage.setItem("sponsorName" , JSON.parse(localStorage.allSponsors)
               .find(x => x.ID === JSON.parse(localStorage.userSponsor)).Name);
           localStorage.setItem('maxCredit', res.data.Content.credit.max_Credit);
           localStorage.setItem('userMonthCredit', res.data.Content.credit.Credit_Month);
           localStorage.setItem('userRemainMonthCredit', res.data.Content.credit.RemainCredit_Month);
           localStorage.setItem('minContractCredit', res.data.Content.Contract.MinCreditAmount);
           localStorage.setItem('maxRemainCredit', res.data.Content.credit.max_remainCredit);
           localStorage.setItem('maxContractCredit', res.data.Content.Contract.MaxCreditAmount);
           localStorage.setItem('minDebtMonth', res.data.Content.Contract.Min_Debt_Month);
           localStorage.setItem('interest', res.data.Content.Contract.interest);
           localStorage.setItem("defaultCashPercent", res.data.Content.Contract.Default_Cash_Percent);
           localStorage.setItem('debts', JSON.stringify(res.data.Content.Contract.debts));
            setStore({
                loading: false,
                step: 4
            })
       }
    }).catch(err => {
     if(err.response.status === 610){
            setStore({
                showModalErr: true
            })
        
        }
    })
}
export function getCreditFromFarhangi(paymenttoken,income , bankacc, accessToken) {
    setStore({
        buttonDisabled: true,
        buttonLoading: true
    });
    const headers = {
        'content-Type': 'application/json',
        'Accept': '*/*',
        'Authorization': `brear ${accessToken}`
    };
    const params = {
        payment_token: paymenttoken,
        net_income: income,
        bank_account: bankacc,
    };
    axios.post(`${kipa}/Get_Credit`,params,{
        headers: headers
    }).then(res => {
        //  localStorage.setItem('minCredit' , res.data.Content.credit.MinCreditAmount);
        if(res.data.Status === 200) {
            localStorage.setItem("sponsorName" , JSON.parse(localStorage.allSponsors)
                .find(x => x.ID === JSON.parse(localStorage.userSponsor)).Name);
            localStorage.setItem('maxCredit' , res.data.Content.credit.max_Credit);
            localStorage.setItem('userMonthCredit' , res.data.Content.credit.Credit_Month);
            localStorage.setItem('userRemainMonthCredit' ,res.data.Content.credit.RemainCredit_Month);
            localStorage.setItem('minContractCredit' ,res.data.Content.Contract.MinCreditAmount);
            localStorage.setItem('maxRemainCredit' ,res.data.Content.credit.max_remainCredit);
            localStorage.setItem('maxContractCredit' ,res.data.Content.Contract.MaxCreditAmount);
            localStorage.setItem('minDebtMonth' ,res.data.Content.Contract.Min_Debt_Month);
            localStorage.setItem('interest' ,res.data.Content.Contract.interest);
            localStorage.setItem("defaultCashPercent" , res.data.Content.Contract.Default_Cash_Percent);
            localStorage.setItem('debts', JSON.stringify(res.data.Content.Contract.debts));
                setStore({
                    buttonDisabled: false,
                    buttonLoading: false,
                    step: 4,
                    loading: false,
                })
        }
        else if(res.data.Status === 613){
            setStore({
                buttonDisabled: false,
                buttonLoading: false,
                loading: false,
                minCreditError: true
            })
        }
    }).catch(err => {
        if(err.response.status === 610){
            setStore({
                showModalErr: true,
                buttonDisabled: false,
                buttonLoading: false,
            })
        }
        else if(err.response.status === 613){
            setStore({
                buttonDisabled: false,
                buttonLoading: false,
                loading: false,
                minCreditError: true
            })
        }
        else{
            setStore({
                serverErr: true,
                showModalErr: true,
            })
        }
    })
}
export function authorization(mobile , code , paymenttoken) {
    setStore({
        loading: true
    });
    const headers = {
        'Accept': '*/*',
    };
    const params = {
        Mobile: mobile,
        payment_token: paymenttoken,
        Code: code
    };
    axios.post(`${kipa}/authorization` , params , {
        headers: headers
    }).then(res => {
        if(res.data.Status === 200){
            localStorage.setItem('customerAccessToken' , res.data.Content.CustomerAccessToken);
            localStorage.setItem('name' , res.data.Content.profile.name);
            localStorage.setItem('lastName' , res.data.Content.profile.last_name);
            localStorage.setItem("userSponsor" , res.data.Content.profile.sponsor );
            if(res.data.Content.profile.sponsor === 111111127 || res.data.Content.profile.sponsor === 111111128 ){
                getCreditFromFarhangi(paymenttoken ,Math.trunc((Math.random() * (6-3)+3) * 10000000).toString(),"11111111111" ,res.data.Content.CustomerAccessToken);
            }else{
                getCredit(paymenttoken , res.data.Content.CustomerAccessToken);
            }
        }else if(res.data.Status === 611){
            setStore({
                loading: false,
                otpErr: true
            });
        }
        else if (res.data.Status === 613){
            setStore({
                step: 1,
                loading: false,
                minCreditError: true
            });
        }
        else {
            setStore({
                serverErr: true,
                showModalErr:  true,
            })
        }
    }).catch(err => {
        if(err.response.status === 613){
            setStore({
                step: 1,
                loading: false,
                minCreditError: true
            });
        }
        else if(err.response.status === 611){
            setStore({
                loading: false,
                otpErr: true
            });
        }
        else{
            setStore({
                serverErr: true,
                showModalErr: true
            });
        }
    })
}
